var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-select',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.items,"required":_vm.required},on:{"input":function($event){return _vm.$emit('input', $event)}}},'p-select',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }